import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from 'components/AuthStyling';
import styles from './index.module.scss';
import { queryStringParser } from 'utils/queryStringParser';
import API from 'services/api';
import {
  upperCaseCharValidation,
  lowerCaseCharValidation,
  specialCharValidation,
  oneNumberValidation,
  validatePassword,
  pwdEqualValidation,
} from 'utils/formValidators';
import errorCheck from 'images/icon_tick.svg';
import IconButton from '@material-ui/core/IconButton';
import Input from 'components/Forms/Fields/TextInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import classNames from 'classnames';
import Button from 'components/Button';
import Image from 'components/Image';
import passwordShow from 'images/icon_visible.svg';
import passwordHide from 'images/icon_invisible.svg';

const ResetPassword = ({ location, history }) => {
  const [user, setUser] = useState({});
  const [touched, setTouched] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [pwdrule, setpwdrule] = useState(false);
  const [validation, setvalidation] = useState({});
  const [showPwd, setshowPwd] = useState(false);
  const [showConfirmPwd, setshowConfirmPwd] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [confirmPwdTest, setConfirmPwdText] = useState();
  const pwdMissMatchText = 'Passwords must match.';

  useEffect(() => {
    async function verifyToken(userId, token) {
      API.verifyToken(userId, token)
        .then(response => console.log('res', response))
        .catch(err => {
          history.push('/pwd-reset/failure');
          console.log(`error: ${err}`);
        });
    }
    const setqueryParams = () => {
      const userId = queryStringParser(location.search, 'u');
      const token = queryStringParser(location.search, 't');

      if ((userId != null) & (token != null)) {
        setUser(user => ({ ...user, userId: userId, token }));
        verifyToken(userId, token);
      } else {
        history.push('/pwd-recover');
      }
    };

    setqueryParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function resetPassword() {
    API.resetPassword(user)
      .then(() => history.push('/pwd-reset/success'))
      .catch(err => console.log(err));
  }

  const submit = event => {
    event.preventDefault();
    resetPassword();
  };

  const validationMsgCheck = fieldValue => {
    //call to check hasUpperCase validation
    const hasUpperCase = upperCaseCharValidation(fieldValue);
    //call to check hasLowerCase validation
    const hasLowerCase = lowerCaseCharValidation(fieldValue);
    //call to check special character validation
    const hasSpecialChar = specialCharValidation(fieldValue);
    //call to check number validation
    const checkNum = oneNumberValidation(fieldValue);
    //call to check minimum length validation
    const hasMinLength = validatePassword(fieldValue);
    setvalidation({
      ...validation,
      hasUpperCase: hasUpperCase,
      hasLowerCase: hasLowerCase,
      hasSpecialChar: hasSpecialChar,
      hasOneNumber: checkNum,
      hasMinLength: hasMinLength,
    });
  };

  const validatePasswordText = ({ password, confirmPassword }) => {
    const equalPwd = pwdEqualValidation(password, confirmPassword);
    if (equalPwd) {
      setFormErrors({ ...formErrors, pwdMissMatch: false });
      setDisableBtn(false);
    } else {
      setFormErrors({ ...formErrors, pwdMissMatch: true });
      setDisableBtn(true);
    }
  };

  const updatePwd = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    setUser({ ...user, [fieldName]: fieldValue });
    setTouched({ ...touched, [fieldName]: true });
    validatePasswordText({
      password: fieldValue,
      confirmPassword: confirmPwdTest,
    });
    validationMsgCheck(fieldValue);
  };
  const enablePwdRule = () => {
    setpwdrule(true);
  };
  const disablePwdRule = () => {
    if (
      validation.hasMinLength &&
      validation.hasUpperCase &&
      validation.hasSpecialChar &&
      validation.hasOneNumber
    ) {
      setpwdrule(false);
    }
  };
  const updateConfirmPwd = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    setTouched({ ...touched, [fieldName]: true });
    setConfirmPwdText(fieldValue);
    validatePasswordText({
      password: user.password,
      confirmPassword: fieldValue,
    });
  };
  const showPassword = () => {
    setshowPwd(!showPwd);
  };
  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  const handleMouseDownconfPwd = event => {
    event.preventDefault();
  };
  const showConfPassword = () => {
    setshowConfirmPwd(!showConfirmPwd);
  };
  const cancel = () => {
    history.push('/login');
  };

  const validationIcon = property => {
    return classNames({
      [styles.validationIcon]: true,
      [styles.hideIcon]: !property,
    });
  };
  return (
    <Header message="Please enter and confirm your new password below:">
      <form className={styles.formContent} noValidate onSubmit={submit}>
        <div className={styles.formArea}>
          <FormControl className={styles.formCntrl}>
            <Input
              id="reset-password"
              className={styles.blackText}
              type={showPwd ? 'text' : 'password'}
              field="password"
              onChange={updatePwd}
              placeholder="New Password"
              onFocus={enablePwdRule}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={showPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    <Image
                      className={styles.pwdIcon}
                      alt=""
                      src={showPwd ? passwordShow : passwordHide}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl className={styles.formCntrl}>
            <Input
              id="re-pwd"
              className={styles.blackText}
              field="confirmPwd"
              type={showConfirmPwd ? 'text' : 'password'}
              onFocus={disablePwdRule}
              onChange={updateConfirmPwd}
              placeholder="Confirm Password"
              error={
                formErrors.pwdMissMatch &&
                touched.confirmPwd &&
                pwdMissMatchText
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={showConfPassword}
                    onMouseDown={handleMouseDownconfPwd}
                  >
                    <Image
                      className={styles.pwdIcon}
                      alt=""
                      src={showPwd ? passwordShow : passwordHide}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        {pwdrule ? (
          <div className={styles.pwdRule}>
            <p>Password must contain:</p>
            <div className={styles.validationMsg}>
              <Image
                alt="upper-case"
                src={errorCheck}
                className={validationIcon(validation.hasUpperCase)}
              />
              <span>at least 1 uppercase letter</span>
            </div>
            <div className={styles.validationMsg}>
              <Image
                alt="lower-case"
                src={errorCheck}
                className={validationIcon(validation.hasLowerCase)}
              />
              <span>at least 1 lowercase letter</span>
            </div>
            <div className={styles.validationMsg}>
              <Image
                alt="special-char"
                src={errorCheck}
                className={validationIcon(validation.hasSpecialChar)}
              />
              <span>at least 1 special character</span>
            </div>
            <div className={styles.validationMsg}>
              <Image
                alt="digit"
                src={errorCheck}
                className={validationIcon(validation.hasOneNumber)}
              />
              <span>at least 1 number</span>
            </div>
            <div className={styles.validationMsg}>
              <Image
                alt="min-length"
                src={errorCheck}
                className={validationIcon(validation.hasMinLength)}
              />
              <span>at least 6 characters</span>
            </div>
          </div>
        ) : null}
        <div className={styles.buttonRow}>
          <Button
            type="button"
            onClick={cancel}
            text="CANCEL"
            color="secondary"
            theme="light"
          />
          <Button
            type="submit"
            text="CHANGE"
            onClick={submit}
            disabled={
              disableBtn ||
              !validation.hasUpperCase ||
              !validation.hasSpecialChar ||
              !validation.hasOneNumber ||
              !validation.hasMinLength
            }
          />
        </div>
      </form>
    </Header>
  );
};
ResetPassword.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
export default ResetPassword;
